import { CustomException } from '@/utils/error';

/**
 * 比较版本1和版本2的高低, 0 相等，-1 v1 < v2， 1 v1 > v2
 * @param v1 版本1
 * @param v2 版本2
 */
export function verCompare(v1: string, v2: string) {
  const v1Arr = v1.split('.');
  const v2Arr = v2.split('.');
  const len = Math.max(v1Arr.length, v2Arr.length);

  while (v1Arr.length < len) {
    v1Arr.push('0');
  }
  while (v2Arr.length < len) {
    v2Arr.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1Arr[i], 10);
    const num2 = parseInt(v2Arr[i], 10);

    if (num1 > num2) {
      return 1;
    } if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}
/**
   * 获取微信版本
   */
export function getWeixinVer() {
  // ...MicroMessenger/7.0.1380(0x2700003D)...获取(0x....)
  let pattern = /MicroMessenger\/[\d.]+\((.*)\)/i;
  // @ts-ignore
  let wc = (navigator.wxuserAgent || navigator.userAgent).match(pattern);
  if (!wc) {
    pattern = /MicroMessenger\/([\d.]+)/i;
    // @ts-ignore
    wc = (navigator.wxuserAgent || navigator.userAgent).match(pattern);
    if (wc) return wc[1];
  }
  if (!wc) return '0.0.0';
  const version = wc[1].slice(3);
  const result: number[] = [];
  result.push(parseInt(version.slice(0, 1), 16));
  result.push(parseInt(version.slice(1, 3), 16));
  result.push(parseInt(version.slice(3, 5), 16));
  return result.join('.') || '0.0.0';
}
/**
   * 比较微信版本大于ver
   * @param ver 比较的版本
   */
export function isWexinVerLargeOrEqualThan(ver) {
  const curVer = getWeixinVer();
  return verCompare(curVer, ver) > -1;
}

/**
   * 获取OS信息
   */
export function getOSInfo() {
  let pattern = /OS ([\d_]+)/i;
  // @ts-ignore
  let wc = (navigator.wxuserAgent || navigator.userAgent).match(pattern);
  const isIos = navigator.userAgent.match(/iPhone|iPad/i);
  if (isIos && wc) return { type: 'iphone', version: wc[1].replace(/_/g, '.') };
  pattern = /Android ([\d.]+)/i;
  // @ts-ignore
  wc = (navigator.wxuserAgent || navigator.userAgent).match(pattern);
  if (wc) return { type: 'android', version: wc[1] };
  new CustomException(navigator.userAgent, 'unKnowOperationSystem', '未知操作系统');
  return { type: 'none', version: '0.0.0' };
}

/**
 * 是否是android
 */
export function isAndroid() {
  return getOSInfo().type === 'android';
}

/**
 * 是否是ios
 */
export function isIos() {
  return getOSInfo().type === 'iphone';
}

/**
   * 判断安卓、ios的版本是否大于等于指定版本
   * @param minVer 两个系统的最低版本
   */
export function isOSVerLargeOrEqualThan(minVer: {
  android?: string;
  iphone?: string;
}) {
  const { type, version } = getOSInfo();

  // 对未知操作系统默认放开权限
  if (type === 'none') return true;

  const ver = minVer[type];
  return verCompare(version, ver) > -1;
}
